import HTTP from "../../../services/HTTP.js";
// fetch Tasks
export const getTasks = async (paramsOptions) => {
  const { page, limit } = paramsOptions || {};
  const res = await HTTP.get("tasks", {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// fetch task history by id
export const getTaskHistoryById = async (paramsOptions) => {
  const { page, limit, taskId } = paramsOptions || {};
  const res = await HTTP.get(`tasks/history/${taskId}`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// add Task
export const addTask = async (data) => {
  const res = await HTTP.post("tasks/add", data);
  return res.data;
};

// update password
export const updateTask = async (data) => {
  const res = await HTTP.put("tasks/update", data);
  return res.data;
};
// delete password
export const deleteTask = async (id) => {
  const res = await HTTP.delete(`tasks/delete/${id}`);
  return res.data;
};
